import React from 'react';

/**
 * Rendering helpers for market-overview prose fields.
 *
 * The market-overview-gen worker strips Perplexity citation markers at generation
 * time and asks the model to wrap key phrases in **bold**. These helpers keep the
 * frontend robust: they strip any leftover citations (so already-stored data that
 * predates the worker fix also renders clean) and turn **...** into <strong>.
 */

// Remove citation markers like "[1]", "[5][7][11]", " [12]" (with leading space).
export function stripCitations(text) {
  return typeof text === 'string' ? text.replace(/\s*\[\d+\]/g, '') : text;
}

/**
 * Render a market-overview text field: strip citations, then render **bold**
 * segments as <strong>. Returns a React node (array of strings + <strong>).
 * A dangling ** (e.g. from truncation cutting inside a bold pair) is dropped
 * rather than shown literally.
 */
export function renderMarketText(text) {
  const clean = stripCitations(text);
  if (!clean || typeof clean !== 'string') return clean;
  // Split on **...** keeping the delimiters so we can wrap them.
  return clean.split(/(\*\*[^*]+\*\*)/g).map((part, i) => {
    const match = /^\*\*([^*]+)\*\*$/.exec(part);
    return match ? <strong key={i}>{match[1]}</strong> : part.replace(/\*\*/g, '');
  });
}
